import React from "react";

import TiktokShare from "components/admin/settings/TiktokShare";
import StoryShareFacebook from "components/facebook/StoryShareFacebook";
import StoryShareInstagram from "components/instagram/StoryShareInstagram";
import StoryShareLinkedin from "components/linkedin/StoryShareLinkedin";

const SocialShareOption = ({ approvedForSocial, approvedMessage, children, story }) => {
  const { socialType } = approvedMessage;
  if (socialType === "facebook") {
    return (
      <StoryShareFacebook approvedForSocial={approvedForSocial} story={story}>
        {children}
      </StoryShareFacebook>
    );
  }

  if (socialType === "instagram") {
    return (
      <StoryShareInstagram approvedForSocial={approvedForSocial} story={story}>
        {children}
      </StoryShareInstagram>
    );
  }

  if (socialType === "linkedin") {
    return (
      <StoryShareLinkedin approvedForSocial={approvedForSocial} story={story}>
        {children}
      </StoryShareLinkedin>
    );
  }

  if (socialType === "tiktok") {
    return (
      <TiktokShare approvedMessage={approvedMessage} story={story}>
        {children}
      </TiktokShare>
    );
  }

  if (socialType === "twitter") {
    return (
      <div>
        {children}
      </div>
    );
  }

  return <></>;
};

export default SocialShareOption;
